import { KeyboardEvent, ReactNode } from 'react';
import Icon from 'components/icons';
import { GroupItemTitle, OpenIndicator } from './styles';

// display:block keeps the icon out of an inline formatting context, so the
// wrapper's baseline is its bottom edge rather than a nested line box. The box is
// oversized because the 24px viewBox only draws within a 20px core: 16.8 * 20/24
// lands the visible glyph on Figma's 14px.
const OPEN_ICON_STYLE = { display: 'block', width: '16.8px', height: '16.8px' };

interface IOpenableTitleProps {
  children: ReactNode;
  onOpen?(): void;
}

/** Content names are the link target; the icon marks them as opening a new tab. */
const OpenableTitle = ({ children, onOpen }: IOpenableTitleProps): JSX.Element => {
  if (!onOpen) return <GroupItemTitle>{children}</GroupItemTitle>;

  // role="link" activates on Enter only, leaving Space to scroll the page.
  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onOpen();
    }
  };

  return (
    <GroupItemTitle $openable role="link" tabIndex={0} onClick={onOpen} onKeyDown={handleKeyDown}>
      {children}
      <OpenIndicator className="open-indicator">
        <Icon icon="ExternalLink" style={OPEN_ICON_STYLE} />
      </OpenIndicator>
    </GroupItemTitle>
  );
};

export default OpenableTitle;
